export enum ContentConnectCampaignStatus {
    DRAFTED='DRAFTED',
    ACTIVE='ACTIVE',
    COMPLETED='COMPLETED',
    STOPPED='STOPPED',
    PAUSED='PAUSED',
    ARCHIVED='ARCHIVED',
}
